import React from 'react';
import { formatMoney } from '../../Shared/Formatters';

const TIER = {
    danger:  { cls: 'tier-danger',  dot: '🔴' },
    watch:   { cls: 'tier-watch',   dot: '🟡' },
    healthy: { cls: 'tier-healthy', dot: '🟢' },
};

function pct(v) {
    if (v == null || isNaN(v)) return 'n/a';
    return `${v > 0 ? '+' : ''}${v.toFixed(1)}%`;
}

/**
 * Flight-risk tenant cards — tier-coloured, with a composite-score gauge bar.
 * Shape from blockBuilder: { items:[{tenant,tier,ocrPct,trendPct,composite,
 * streakDays}], atRiskRevenue, labels }. Clicking asks to drill into the tenant.
 */
export default function RiskTierCards({ title, items, atRiskRevenue, labels, onSuggest }) {
    if (!items?.length) return null;
    return (
        <div className="chat-block">
            {title && <div className="chat-block-title">{title}</div>}
            <div className="risk-cards">
                {items.map((it, i) => {
                    const tier = TIER[it.tier] || TIER.healthy;
                    const score = it.composite != null ? Math.max(0, Math.min(100, it.composite)) : null;
                    const clickable = Boolean(onSuggest && it.tenant);
                    return (
                        <div
                            key={i}
                            className={`risk-card ${tier.cls}${clickable ? ' clickable' : ''}`}
                            onClick={clickable ? () => onSuggest(`Drill into ${it.tenant}`) : undefined}
                            title={clickable ? `Drill into ${it.tenant}` : undefined}
                        >
                            <div className="risk-card-head">
                                <span className="risk-tenant">{tier.dot} {it.tenant}</span>
                                {score != null && <span className="risk-score">{score}</span>}
                            </div>
                            {score != null && (
                                <div className="risk-gauge">
                                    <div className="risk-gauge-fill" style={{ width: `${score}%` }} />
                                </div>
                            )}
                            <div className="risk-card-meta">
                                {it.ocrPct != null && <span>{labels?.ocr}: {it.ocrPct.toFixed(1)}%</span>}
                                {it.trendPct != null && <span>{labels?.trend}: {pct(it.trendPct)}</span>}
                                {it.streakDays != null && (
                                    <span className="risk-streak">
                                        {(labels?.streakTemplate || '{n}d zero-sales').split('{n}').join(it.streakDays)}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
            {atRiskRevenue != null && (
                <div className="risk-footer">— {labels?.atRisk}: {formatMoney(atRiskRevenue)}</div>
            )}
        </div>
    );
}
